/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import {
  Grid,
  Tooltip,
  Typography,
  Divider,
  IconButton,
  Backdrop,
} from "@material-ui/core";

import MaterialTable, { MTableToolbar } from "material-table";
import table_icons from "../tableIcons";
import HighlightOff from "@material-ui/icons/HighlightOff";

import CheckCircleOutlined from "@material-ui/icons/CheckCircleOutlined";
import AutorenewTwoToneIcon from "@material-ui/icons/AutorenewTwoTone";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";
import Add from "@material-ui/icons/Add";
import Refresh from "@material-ui/icons/Refresh";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import ScheduleIcon from "@material-ui/icons/Schedule";
import EditOutlined from "@material-ui/icons/EditOutlined";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartNetwork,
  faSnooze,
  faMicrochip,
  faTrash,
  faCalendar,
} from "@fortawesome/pro-duotone-svg-icons";
import Scheduler from "../Scheduler/Scheduler";
import Actions from "./../../fluid/Actions/ActionFactory.js";

import AddScript from "../CreateScript/AddScript";

import { DeleteConfirmationDialog } from "./../Utilities/DeleteConfirmationDialog";
import ErrorMessageAlert from "../Utilities/ErrorMessageAlert";

import SecureWrapper from "../Security/SecureWrapper";
import { allowedByOpop } from "../Security/SecureCheck";

const clone = require("rfdc")();

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    // primary: {
    //     main: "#FF6600",
    //     contrastText: "#FFFFFFFF"
    // },
    secondary: {
      main: "#dc004e",
    },
  },
});

const styles = (theme) => ({
  "@keyframes pulsate": {
    from: {
      opacity: 0.25,
    },
    to: {
      opacity: 1.0,
    },
  },
  active: {
    color: "#4caf50",
    fontSize: "15px",
  },
  running: {
    color: "#4caf50",
    fontSize: "15px",
    animation: "$pulsate 250ms infinite alternate",
  },
  deactive: {
    color: "#FF8C02",
    fontSize: "15px",
    animation: "$pulsate 3000ms infinite alternate",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  "@keyframes spin": {
    from: { transform: "rotate(0deg)" },
    to: { transform: "rotate(360deg)" },
  },
  "@keyframes slide": {
    from: { left: "0px" },
    tp: { right: "30px" },
  },
  in_progress: {
    color: "#039be5",
    textAlign: "center",
    animation: "$spin 2s infinite linear",
  },
  in_progress_dt: {
    color: "#039be5",
    textAlign: "center",
    animation: "$slide 2s infinite linear",
  },
});

class ScriptsList extends Component {
  state = {
    scripts_data: [],
    adding_script: false,
    script_name: null,
    isLoading: true,
    editing_script: false,
    script_details: null,
    deletingItem: {},
    errorOpen: false,
    errorInfo: {},
    confirmDeleteDialogOpen: false,
  };

  componentDidMount() {
    this.getScripts();
  }

  getScripts = () => {
    this.setState({ ...this.state, isLoading: true }, () => {
      Actions("http_request", {
        url: "/sainapse/bot/",
        method: "get",
        data: {},
      })
        .then((res) => {
          this.setState(
            { ...this.state, scripts_data: res.data.result },
            () => {
              this.setState({ isLoading: false });
            }
          );
        })
        .catch((err) => console.log("Error"));
    });
  };

  cancelDelete = () => {
    this.setState({ deletingItem: {}, confirmDeleteDialogOpen: false });
  };

  confirmDelete = () => {
    this.setState({ confirmDeleteDialogOpen: false });

    Actions("http_request", {
      url: "/sainapse/bot/" + this.state.deletingItem.id,
      method: "delete",
      // data : {}
    })
      .then((res) => {
        this.getScripts();
        this.setState({ deletingItem: {} });
      })
      .catch((err) =>
        this.setState({
          deletingItem: {},
          errorOpen: true,
          errorInfo: err,
        })
      );
  };

  //delete
  deleteScript = (rowData) => {
    this.setState({ deletingItem: rowData, confirmDeleteDialogOpen: true });
  };

  //error
  handleErrorClose = () => {
    this.setState({ errorOpen: false, errorInfo: {} });
  };

  handlePopupClose = () => {
    this.setState({ adding_script: false, editing_script: false }, () => {
      this.getScripts();
    });
  };

  goToCreateScript = () => {
    this.setState({ adding_script: true });
  };

  getScriptDetails = (script_details) => {
    this.setState({ script_details: script_details, editing_script: true });
  };
  getDisableStatus= (id) => {
    
    return !allowedByOpop({
      operation : "/sainapse/bot/{id}",
      method : "DELETE",
      operands : [
        {
          attrName: "id",
          value : id
    }]
    })
  };
  renderActions = (row_data) => {
    if (
      row_data.id !== this.state.deletingItem.id ||
      this.state.confirmDeleteDialogOpen
    ) {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Tooltip title="Edit" arrow>
            <IconButton
              size="small"
              style={{ marginRight: "0px" }}
              onClick={() => this.getScriptDetails(row_data)}
              disabled = {!allowedByOpop({
                operation : "/sainapse/bot/{id}",
                method : "PUT",
                operands : [
                  {
                    attrName: "id",
                    value : row_data.id
              }]
              })}
            >
              <EditOutlined fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete" arrow>
            <IconButton
              size="small"
              style={{ color: !this.getDisableStatus(row_data.id) ? "#f44336": "rgb(0,0,0,0.3)", marginRight: "0px" }}
              onClick={() => this.deleteScript(row_data)}
              disabled = {this.getDisableStatus(row_data.id)}
            >
              <DeleteOutline fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      );
    } else {
      return <Typography variant="overline">Deleting...</Typography>;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <Grid>
        <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/bot",
                        method : "GET",
                        operands : []
                      }}
                      shouldRenderErrorMessage = {true}
                      errorMessage = "User does not have sufficient privileges"
                      textVariant = "subtitle2"
                    >
        <MaterialTable
          style={{ width: "100vw", height: "calc(100vh - 48px)" }}
          title="Scripts"
          icons={table_icons}
          columns={[
            {
              title: "Name",
              field: "name",
              cellStyle: {
                textAlign: "left",
              },
            },
            {
              title: "Details",
              field: "description",
              cellStyle: {
                textAlign: "left",
              },
            },
            {
              title: "Registration Time",
              field: "created_date",
              type: "datetime",
            },
            {
              title: "Last Triggered Time",
              field: "last_trigger_time",
              type: "datetime",
            },
            {
              title: "Last Completion Time",
              field: "last_completion_time",
              type: "datetime",
            },
            {
              title: "Actions",
              field: "actions",
              render: (rowData) => {
                return this.renderActions(rowData);
              },
            },
          ]}
          data={this.state.scripts_data || []}
          options={{
            search: true,
            cellStyle: {
              height: "5vh",
              paddingTop: 0,
              paddingBottom: 0,
              textAlign: "center",
            },
            toolbarButtonAlignment: "right",
            paging: false,
            pageSize: 10,
            pageSizeOptions: [10, 20, 50],
            headerStyle: {
              height: "7vh",
              padding: 0,
              margin: 0,
              textAlign: "center",
              backgroundColor: "#F0F0F0",
              lineHeight: "1.25",
            },
            maxBodyHeight: "78vh",
            detailPanelType: "single",
            draggable: false,
          }}
          isLoading={this.state.isLoading}
          components={{
            Toolbar: (props) => (
              <Fragment>
                <MTableToolbar {...props} />
                <Divider />
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row-reverse",
                    height: "5vh",
                    alignContent: "flex-end",
                  }}
                >
                  <ThemeProvider theme={blue_theme}>
                  <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/bot",
                        method : "GET",
                        operands : []
                      }}
                    >
                    <Tooltip title="Refresh" onClick={this.getScripts}>
                      <IconButton color="primary">
                        <Refresh />
                      </IconButton>
                    </Tooltip>
                    </SecureWrapper>
                    <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/bot",
                        method : "POST",
                        operands : []
                      }}
                    >
                    <Tooltip title="Add Script">
                      <IconButton
                        color="primary"
                        onClick={this.goToCreateScript}
                      >
                        <Add />
                      </IconButton>
                    </Tooltip>
                    </SecureWrapper>
                  </ThemeProvider>
                </div>
                <Divider />
              </Fragment>
            ),
          }}
        />
        </SecureWrapper>
        {this.state.adding_script === true && (
          <Backdrop
            className={classes.backdrop}
            style={{ width: "100vw", height: "100vh" }}
            open={this.state.adding_script}
          >
            <AddScript
              script_name={this.state.script_name}
              close={this.handlePopupClose}
              script_details={this.state.script_details}
              edit_mode={false}
            />
          </Backdrop>
        )}

        {this.state.editing_script === true && (
          <Backdrop
            className={classes.backdrop}
            style={{ width: "100vw", height: "100vh" }}
            open={this.state.editing_script}
          >
            <AddScript
              script_name={this.state.script_name}
              close={this.handlePopupClose}
              script_details={this.state.script_details}
              edit_mode={true}
            />
          </Backdrop>
        )}
        {this.state.errorOpen ? (
          <ErrorMessageAlert
            open={this.state.errorOpen}
            handleClose={this.handleErrorClose}
            errorInfo={this.state.errorInfo}
          ></ErrorMessageAlert>
        ) : null}
        <DeleteConfirmationDialog
          open={this.state.confirmDeleteDialogOpen}
          name={this.state.deletingItem.name}
          type={"Script"}
          confirmDeleteHandler={this.confirmDelete}
          cancelDeleteHandler={this.cancelDelete}
        ></DeleteConfirmationDialog>
      </Grid>
    );
  }
}

export default withRouter(withStyles(styles)(ScriptsList));
